import { ReportCommandRequest, RequestDataSource } from "@/models/formUtility";
import type { ApiResponse } from "./apiService";
import { apiGet, apiPost } from "./apiService";

export function getCommandTextAsync(): Promise<ApiResponse<string[]>> {
    return apiGet<string[]>("FormUtility/GetCommandText");
}
export function getFolderAsync(): Promise<ApiResponse<string[]>> {
    return apiGet<string[]>("FormUtility/GetFolder");
}
export function isRenameAuthorize(): Promise<ApiResponse<boolean>> {
    return apiGet<boolean>("FormUtility/RenameAuthenticate");
}
export function getReportDataAsync(request: RequestDataSource): Promise<ApiResponse<[]>> {
    return apiPost<[]>("FormUtility/GetReportData", request);
}

export function renameReport(request: ReportCommandRequest): Promise<ApiResponse<[]>> {
    return apiPost<[]>("FormUtility/RenameReportCommand", request);
}